// @flow
import SearchTemplate from './SearchTemplate';

export default SearchTemplate;



// WEBPACK FOOTER //
// ./src/components/search/SearchTemplate/index.js